
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('filter',{attrs:{"id":"a"}},[_c('feColorMatrix',{attrs:{"in":"SourceGraphic","values":"0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"}})])]),_c('g',{attrs:{"filter":"url(#a)","transform":"translate(-8 -8)","fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#252626","d":"M19 12v4a1 1 0 01-1 1h-6a1 1 0 01-1-1v-4a1 1 0 011-1h6a1 1 0 011 1zm-1 7h-6a1 1 0 00-1 1v8a1 1 0 001 1h6a1 1 0 001-1v-8a1 1 0 00-1-1zm10 4h-6a1 1 0 00-1 1v4a1 1 0 001 1h6a1 1 0 001-1v-4a1 1 0 00-1-1zm0-12h-6a1 1 0 00-1 1v8a1 1 0 001 1h6a1 1 0 001-1v-8a1 1 0 00-1-1z"}})])])
          )
        }
      }
    